import {
    MyLearningUnit,
    MyLearningUnitProps,
    useMyLearningUnitTabState,
} from '@udemy/react-my-learning-unit';

import {UserEnrollmentsData} from 'src/types/page-props';

interface MyLearningUnitContainerProps extends MyLearningUnitProps {
    preloadedData?: UserEnrollmentsData;
}

export const MyLearningUnitContainer = ({
    title,
    url,
    learningTabs,
    preloadedData,
}: MyLearningUnitContainerProps) => {
    const {allTabsHaveLoaded, hasAnyContent} = useMyLearningUnitTabState();

    if (allTabsHaveLoaded && !hasAnyContent) {
        return null;
    }

    return (
        <MyLearningUnit
            title={title}
            url={url}
            learningTabs={learningTabs}
            disableLoadingStates={!!preloadedData}
            preloadedData={{data: preloadedData}}
        />
    );
};
